export default async (...params: Parameters<typeof fetch>) => {
  const response = await fetch(...params);

  if (response.ok) {
    return response.text();
  }

  throw new Error(`Could not fetch URL: "${params[0]}". Server responded with: ${response.status}`);
};
